import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../appRedux/store";
import { CustomNotification } from "../../../util/CustomNotification";
import { ErrorMessageConstants } from "../../../constants/MessageConstants/ErrorMessageConstants";
import moment, { Moment } from "moment-timezone";
import * as reportService from "../../../services/reportsService";

import type { RangeValue } from "rc-picker/lib/interface";
import type { AllTotalBookingRetrievalCountData } from "../../../shared/interface/Report/totalBookingAndRetrieval.interface";

export const useBookingRetrievalReport = () => {
  /* Default last 30 selected */
  const days = 30;
  const to = moment();
  const from = moment().subtract(days, "days").startOf("day");

  /* STATE */
  const [dataCount, setDataCount] = useState<AllTotalBookingRetrievalCountData | null>(null);
  const [loading, setLoading] = useState(false);
  const { masterFilters } = useSelector((state: RootState) => state.common);
  const [startDate, setStartDate] = useState<string | null>(from.format("DD-MM-YYYY HH:mm"));
  const [endDate, setEndDate] = useState<string | null>(to.format("DD-MM-YYYY HH:mm"));

  const handleDateRangeChange = (values: RangeValue<Moment>, formatString: [string, string]) => {
    if (values && values[0] && values[1]) {
      setStartDate(formatString[0]);
      setEndDate(formatString[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const fetchAllDataCount = async () => {
    try {
      if (!masterFilters?.customerId || !masterFilters?.locationId) {
        CustomNotification.showErrorMessage(ErrorMessageConstants.SELECT_CUSTOMER_LOCATION_FILTER);
        return;
      }

      setLoading(true);

      const params = {
        fromDate: startDate,
        toDate: endDate,
        customerId: masterFilters?.customerId,
        locationId: masterFilters?.locationId
      };

      const response = await reportService.getTotalBookingRetrievalCount(params);

      setDataCount(response?.data);
    } catch (error) {
      CustomNotification.showErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (masterFilters?.customerId && masterFilters?.locationId) {
      fetchAllDataCount();
    }
  }, [masterFilters?.customerId, masterFilters?.locationId]);

  return {
    dataCount,
    loading,
    fetchAllDataCount,
    setStartDate,
    setEndDate,
    startDate,
    endDate,
    handleDateRangeChange
  };
};
